import React from 'react';
import Colors from '../../../../../themes/Colors';
import SelectionCardComponent from '../../../../../components/SelectionCardComponent';
import CampaignInfoPanel from './CampaignInfoPanel';

const panelStyle = {
  background: Colors.snow,
  borderRadius: 4,
  marginBottom: 24,
  border: 0,
  padding: 24,
  boxShadow: 'rgba(0, 0, 0, 0.25) 1px 2px 4px 0px',
};

const StepInfo = (props) => {
  const {
    creationType,
    setCreationType,
    errors = {},
    blockCreationType,
    resetCampaignData,
    editCampaignActive,
  } = props;

  return (
    <div className="step-info">
      {!editCampaignActive && (
        <div
          className="contentFilter campaingInfoCard customPanelStyleDisplays"
          style={{ border: errors['creationType'] ? `1px solid ${Colors.red}` : 'none' }}
        >
          <SelectionCardComponent
            creationType={creationType}
            setCreationType={setCreationType}
            errors={errors}
            blockCreationType={blockCreationType}
            resetCampaignData={resetCampaignData}
          />
        </div>
      )}

      <div style={panelStyle}>
        <CampaignInfoPanel {...props} errors={errors} />
      </div>
    </div>
  );
};

export default StepInfo;
